module.exports = __webpack_public_path__ + "img/cb3p-r-y1.b57b2ebd.gif";